// removed by extract-text-webpack-plugin
module.exports = {"header":"header__2MqSo","brand":"brand__CwE_Z","logo":"logo__1Ig25","active":"active__27Q54"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 2